// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-toggle-track {
  background-color: #3e90f0 !important;
}

.react-toggle-track:hover {
  background-color: #0d6efd !important;
}

.react-toggle--checked .react-toggle-track {
  background-color: #3EDD78 !important;
}

.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: #3EDD78 !important;
}

.monthly-text {
  font-family: Inter;
  font-weight: 700;
  padding-right: 10px;
}

.yearly-text {
  font-family: Inter;
  font-weight: 700;
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/SelectPlan/selectplan.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AACF","sourcesContent":[".react-toggle-track {\n  background-color: #3e90f0 !important;\n}\n\n.react-toggle-track:hover {\n  background-color: #0d6efd !important;\n}\n\n.react-toggle--checked .react-toggle-track {\n  background-color: #3EDD78 !important;\n}\n\n.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {\n  background-color: #3EDD78 !important;\n}\n\n.monthly-text {\n  font-family: Inter;\n  font-weight: 700;\n  padding-right: 10px;\n}\n\n.yearly-text {\n  font-family: Inter;\n  font-weight: 700;\n  padding-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
